import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Card, Grid, Progress, Accordion } from 'semantic-ui-react';
import { has } from 'lodash';
import classNames from 'classnames';

import {
  showSidebarMessagesPanel,
  hideSidebarMessagesPanel,
  removeSidebarMessage,
} from 'Common/UI/state/actions';
import * as GlobalUISelectors from 'Common/UI/state/selectors';

import {
  SIDEBAR_MESSAGE_STATUS_NAME,
  SIDEBAR_MESSAGE_STATUS,
} from './Constants';

const MessageCard = ({ title, description, status, source, data }) => (
  <Card
    datasource={source}
    className={`status-${SIDEBAR_MESSAGE_STATUS_NAME[status]}`}
  >
    <Card.Content>
      {title && <Card.Header>{title}</Card.Header>}
      {description && <Card.Description>{description}</Card.Description>}
      {data && has(data, 'Percentage') && (
        <Progress progress="percent" percent={data.Percentage} indicating />
      )}
    </Card.Content>
  </Card>
);

class MessagesComponentContainer extends React.Component {
  static propTypes = {
    isActive: PropTypes.bool.isRequired,
    messages: PropTypes.array.isRequired,
  };

  state = { collapsed: false };

  hidePanelTimeoutId = null;
  scheduledForRemoval = [];

  componentDidUpdate(prevProps) {
    const { messages } = this.props;

    // Start a timeout to hide the messages panel if the messages array is empty.
    if (prevProps.messages.length > 0 && messages.length === 0) {
      this.startHidingPanel();
    }

    // On first message recieved:
    // Ensure the panel is shown and expanded.
    // Cancel hiding the panel if it is scheduled to hide.
    if (prevProps.messages.length === 0 && messages.length > 0) {
      this.stopHidingPanel();
      this.expandPanel();
    }

    // Start removal of message streams that have status success or error.
    // Cancel removals that had a status changed to other than success or error.
    this.handleMessageRemovals();
  }

  startHidingPanel() {
    this.hidePanelTimeoutId = setTimeout(() => {
      this.props.hideSidebarMessagesPanel();
      this.hidePanelTimeoutId = null;
    }, 2000);
  }

  stopHidingPanel() {
    if (this.hidePanelTimeoutId) {
      clearTimeout(this.hidePanelTimeoutId);
    }
  }

  expandPanel() {
    this.props.showSidebarMessagesPanel();
    this.setState({ collapsed: false });
  }

  handleMessageRemovals() {
    this.props.messages.forEach(({ Status, Id }) => {
      if (
        Status === SIDEBAR_MESSAGE_STATUS.Success ||
        Status === SIDEBAR_MESSAGE_STATUS.Error
      ) {
        this.scheduledForRemoval.push({
          id: Id,
          timeoutId: setTimeout(
            () => this.props.removeSidebarMessage(Id),
            4000
          ),
        });
        return;
      }

      // If the message stream was scheduled for removal, cancel it since its status changed.
      const index = this.scheduledForRemoval.findIndex(i => i.id === Id);
      if (index !== -1) {
        const { timeoutId } = this.scheduledForRemoval.splice(index, 1)[0];
        clearTimeout(timeoutId);
      }
    });
  }

  render() {
    const { messages, isActive } = this.props;
    const { collapsed } = this.state;

    return (
      isActive && (
        <div className="app-sidebar-messages">
          <Accordion>
            <Accordion.Title
              onClick={() => this.setState({ collapsed: !collapsed })}
              className={classNames('display-trigger', { active: !collapsed })}
            >
              Work In Progress
              <span className="message-count pull-right">
                {messages.length}
              </span>
            </Accordion.Title>
            <Accordion.Content active={!collapsed}>
              <Grid container>
                {messages.map(msg => (
                  <Grid.Row columns={1} key={msg.Id}>
                    <Grid.Column>
                      <MessageCard
                        source={msg.Source}
                        title={msg.Message.Title}
                        description={msg.Message.Description}
                        status={msg.Status}
                        data={msg.Data}
                      />
                    </Grid.Column>
                  </Grid.Row>
                ))}
              </Grid>
            </Accordion.Content>
          </Accordion>
        </div>
      )
    );
  }
}

const mapStateToProps = state => ({
  isActive: GlobalUISelectors.getIsSidebarMessagesPanelActive(state),
  messages: GlobalUISelectors.getSidebarMessages(state),
});

const mapDispatchToProps = {
  showSidebarMessagesPanel,
  hideSidebarMessagesPanel,
  removeSidebarMessage,
};

export const MessagesComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(MessagesComponentContainer);



// WEBPACK FOOTER //
// ./src/components/app/sidebar/Messages.js